/* eslint-disable ts/no-explicit-any */
import { SuiteAdapter } from "@peerup/suite/adapter"
import { isFeishuRobot } from "@peerup/utils"
import { message as subMessage } from "ant-design-vue"

const data = SuiteAdapter.getGlobalData<{
  message?: typeof subMessage
}>()
const sub_message = data?.message || subMessage
export interface MessageArgsProps {
  content?: { content: Element }
  duration?: number
  prefixCls?: string
  rootPrefixCls?: string
  onClose?: () => void
  key?: string | number
  class?: string
  sub_type?: string
  onClick?: (e: MouseEvent) => void
  maxCount?: number
}

const message: {
  [key: string]: (
    content?: MessageArgsProps | string,
    duration?: number,
    sub_type?: string,
    onClose?: (e: MouseEvent) => void,
  ) => () => void
} = {}

const createMessage = (type: string) => {
  message[type] = (
    content?: MessageArgsProps | string,
    duration?: number,
    sub_type?: string,
    onClose?: (e: MouseEvent) => void,
  ) => {
    if (isFeishuRobot) return
    return Object.prototype.toString.call(content) === "[object Object]"
      && !!(content as MessageArgsProps).content
      ? (sub_message as any)[type]({
          ...(content as MessageArgsProps),
          class:
            `${type}-message${(content as MessageArgsProps).class}`
              ? ` ${(content as MessageArgsProps).class}`
              : "",
        })
      : (sub_message as any)[type]({
          content,
          class: `${type}-message${content ? ` ${(content as MessageArgsProps).class}` : ""}`,
          duration,
          type: sub_type,
          onClose,
        })
  }
}
const TOAST: string[] = [
  "success",
  "info",
  "warning",
  "warn",
  "error",
  "loading",
]

TOAST.forEach(type => createMessage(type))

const NAME_MAP: string[] = ["destroy"]

NAME_MAP.forEach(item => {
  message[item] = (sub_message as any)[item]
})

const allMotheds: string[] = Reflect
  ? (Reflect.ownKeys(sub_message) as string[])
  : (Object.getOwnPropertyNames(sub_message) as string[])

allMotheds
  .filter(item => !TOAST.includes(item))
  .forEach(mothed => {
    message[mothed] = (sub_message as any)[mothed]
  })

export { message }
